export const baseUrl = "https://ssc-cms.habarihealth.com";
// export const baseUrl = "https://ssc-website-cms.herokuapp.com";
// export const baseUrl = "http://localhost:1337";
